module.exports = __webpack_public_path__ + "img/red-package.a7d1be0f.png";